import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'i18next';

import { SnackbarFunctionProps } from '@lyearn/ui';
import { ResourceTypeEnum } from '@/types/schema';

export interface ImageVerificationResponse {
  success: boolean;
  message: string;
}

export interface ImageVerificationApiResponse {
  success: boolean;
  result: FaceVerificationAPIRespone;
}
export enum FaceVerificationAPIResponeStatusEnum {
  FAILED = 'FAILED',
  OK = 'OK',
}
export interface FaceVerificationAPIRespone {
  status: FaceVerificationAPIResponeStatusEnum;
  distance: number;
  err_msg: string;
  verify: boolean;
  err_code: string;
}

export enum ErrorCodeEnum {
  FAILED = 'FAILED',
  MULTIPLE_FACES = 'MULTIPLE_FACES',
  NO_FACE = 'NO_FACE',
  SPOOF = 'SPOOF',
  FACE_DOES_NOT_MATCH = 'FACE_DOES_NOT_MATCH',
}

export interface FaceVerificationInput {
  userUniqueId: string;
  entityId: string;
  parentEntityId?: string;
  entityType?: ResourceTypeEnum;
  parentEntityType?: ResourceTypeEnum;
  base64?: string;
}

export interface VerifyFaceProps {
  url: string;
  data: FaceVerificationInput;
  setIsFaceVerificationModalOpen: Dispatch<SetStateAction<boolean>>;
  setNoOfAttemptsLeft: Dispatch<SetStateAction<number>>;
  setIsRetryDialogOpen: Dispatch<SetStateAction<boolean>>;
  t: TFunction;
  setBackgroundVerification: Dispatch<SetStateAction<boolean>>;
  showSnackbar: (props: SnackbarFunctionProps) => void;
  backgroundVerification: boolean;
}

export interface UseFaceVerificationProps {
  entityId: string;
}

export interface IsFaceVerificationNeededProps {
  userUniqueId: string;
  isAdmin: boolean;
  enableFaceVerification: boolean;
}
